<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              @onFarmChange="onFarmIdsChanged"
              classFarms="col-12 col-md-6"
              :isRequiredFarms="true"
              :filterOfLots="false"
            >
              <template slot="after-lot">
                <select-component
                  :rowClass="`pt-3 col-12 col-md-6`"
                  :labelSelect="`${$t('labor.workers')}:`"
                  :disabled="!avaliableWorkers || avaliableWorkers.length === 0"
                  :dataOptions="avaliableWorkers"
                  @onChange="handleChangeSelected"
                  modelName="worker_ids"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card class="custom-shadow-card-header" v-if="tableData.length > 0">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          />
          <master-table :infoTable="queriedData" :columns="tableColumns" />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <!-- <export-tables
            :pdf="{
              filename: `${$t('production.production_vs_climate')}.pdf`,
              route: 'summary/productionvsclimate/pdf',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
            :xls="{
              filename: `${$t('production.production_vs_climate')}.xlsx`,
              route: 'summary/productionvsclimate/excel',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
          /> -->
          <br />
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import configTable from './ReportTable';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    [Filter.name]: Filter,
  },

  computed: {
    ...configTable().Search,
    exportData() {
      const response = {
        data: { ...this.tableData },
      };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getWorkers() {
      if (this.farm_ids) {
        return this.concatAll(
          this.workers.filter((worker) =>
            this.farm_ids.includes(worker.farm_id)
          )
        );
      }

      return this.concatAll(this.workers);
    },
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
      workers: [],
      avaliableWorkers: [],

      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        bySel: 'Día',
        farm: [],
        worker_ids: [],
      },
    };
  },

  mixins: [MixinMasters, MixinMenu, MixinForm, MixinPermissions],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    onFarmIdsChanged(newFarmData) {
      var farmIds =
        newFarmData && newFarmData.farm_ids ? newFarmData.farm_ids : [];

      if (Array.isArray(farmIds)) {
        this.avaliableWorkers = this.concatAll(
          this.workers.filter(function (worker) {
            return farmIds.includes(worker.farm_id);
          })
        );
      } else {
        console.warn(
          'farm_ids no es un array válido. Valor recibido:',
          farmIds
        );
        this.avaliableWorkers = this.concatAll(this.workers);
      }
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
    },

    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datef: data.datef,
        datei: data.datei,
        bySel: data.bySel,
        farm: data.farm,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.getData();
        } else {
          SweetAlert.warning(i18n.t('production.check_degree_limits'));
        }
      });
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleView(_, row) {
      this.rowData = {
        ...row,
      };
      this.modals['read'] = true;
    },

    getData() {
      this.showHideLoading(true);
      let data = { ...this.dataFilter, route: 'works/payroll' };

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      Axios.postMasters(data)
        .then((response) => {
          if (response.data.data.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.tableData = response.data.data;
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 5;
      this.pagination.currentPage = 1;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('works/workers/indexField')
        .then((responseWorkers) => {
          this.workers = this.concatAll(responseWorkers.data.data);
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showMessageAccess();
    }
  },

  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },

  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
